import { render, staticRenderFns } from "./xmxunjbaojzdgys.vue?vue&type=template&id=55beebe5"
import script from "./xmxunjbaojzdgys.vue?vue&type=script&lang=js"
export * from "./xmxunjbaojzdgys.vue?vue&type=script&lang=js"
import style0 from "./xmxunjbaojzdgys.vue?vue&type=style&index=0&id=55beebe5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports